(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const TH = window.TH || {};
  let lastFocus = null;

  const toast = (msg) => {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  const openDrawer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 50);
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
  };
  const closeDrawer = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    lastFocus && lastFocus.focus && lastFocus.focus();
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) { e.preventDefault(); openDrawer(document.getElementById(open.dataset.openDrawer)); return; }
    const close = e.target.closest('[data-close-drawer]');
    if (close) { closeDrawer(close.closest('.drawer')); return; }
    const cart = e.target.closest('[data-open-cart]');
    if (cart && TH.drawer && $('#cart-drawer')) { e.preventDefault(); openDrawer($('#cart-drawer')); return; }
    if (e.target.closest('[data-open-search]')) { openSearch(); return; }
    if (e.target.closest('[data-close-search]') || e.target.id === 'search-modal') { closeSearch(); return; }
    if (e.target.closest('[data-open-filters]')) { $('#filters') && $('#filters').classList.add('is-open'); return; }
    if (e.target.closest('[data-close-filters]')) { $('#filters') && $('#filters').classList.remove('is-open'); return; }
    const rb = e.target.closest('[data-rail-nav] button');
    if (rb) {
      const rail = document.getElementById(rb.parentElement.dataset.railNav);
      if (rail) rail.scrollBy({ left: rail.clientWidth * 0.9 * Number(rb.dataset.dir), behavior: 'smooth' });
      return;
    }
    const q = e.target.closest('[data-qty]');
    if (q) {
      const input = q.parentElement.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(q.dataset.qty));
      return;
    }
    const lq = e.target.closest('[data-line-qty]');
    if (lq) { changeLine(lq.closest('[data-key]').dataset.key, Number(lq.dataset.lineQty)); return; }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      closeSearch();
      $('#filters') && $('#filters').classList.remove('is-open');
    }
    if (e.key === '/' && !/input|textarea/i.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
  });

  const modal = $('#search-modal');
  const input = $('#search-input');
  const results = $('#search-results');
  function openSearch() { if (!modal) return; lastFocus = document.activeElement; modal.classList.add('is-open'); setTimeout(() => input && input.focus(), 30); }
  function closeSearch() { if (modal && modal.classList.contains('is-open')) { modal.classList.remove('is-open'); lastFocus && lastFocus.focus && lastFocus.focus(); } }
  let st;
  input && input.addEventListener('input', () => {
    clearTimeout(st);
    const term = input.value.trim();
    if (term.length < 2) { results.innerHTML = ''; return; }
    st = setTimeout(async () => {
      try {
        const r = await fetch(`${TH.routes.search}.json?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=8`);
        const d = await r.json();
        const prods = (d.resources.results.products || []);
        const cols = (d.resources.results.collections || []);
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        let html = cols.slice(0, 3).map((c) => `<a href="${c.url}"><span style="width:56px;height:56px;border-radius:10px;background:var(--c-cream);display:flex;align-items:center;justify-content:center">↗</span><span>${esc(c.title)}<small>Colección</small></span></a>`).join('');
        html += prods.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy">` : '<span></span>'}<span>${esc(p.title)}<small>${esc(String(p.price).replace('.', ','))} €</small></span></a>`).join('');
        html += `<a href="/search?type=product&q=${encodeURIComponent(term)}" style="justify-content:center;font-weight:600">Ver todos los resultados →</a>`;
        results.innerHTML = prods.length || cols.length ? html : '<p style="padding:12px;color:var(--c-muted)">Sin resultados</p>';
      } catch (err) { results.innerHTML = ''; }
    }, 220);
  });

  const updateCount = (n) => $$('[data-cart-count]').forEach((el) => { el.dataset.count = n; el.textContent = n > 0 ? n : ''; });
  const renderSections = (sections) => {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#cart-drawer');
      const cur = $('#cart-drawer');
      if (fresh && cur) {
        const wasOpen = cur.classList.contains('is-open');
        cur.replaceWith(fresh);
        if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
      }
    }
  };

  async function changeLine(key, quantity) {
    try {
      const r = await fetch(TH.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'] }) });
      const d = await r.json();
      if (d.status) { toast(d.description || d.message); return; }
      updateCount(d.item_count);
      if ($('[data-cart-page]') || (d.item_count === 0 && document.body.classList.contains('tpl-cart'))) { location.reload(); return; }
      renderSections(d.sections);
    } catch (e) { location.reload(); }
  }

  document.addEventListener('change', (e) => {
    const li = e.target.closest('[data-line-input]');
    if (li) changeLine(li.closest('[data-key]').dataset.key, Math.max(0, parseInt(li.value, 10) || 0));
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const u = new URL(location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    }
    const f = e.target.closest('[data-facets]');
    if (f && window.matchMedia('(min-width: 1000px)').matches) submitFacets(f);
  });
  const submitFacets = (f) => {
    const u = new URL(location.pathname, location.origin);
    new FormData(f).forEach((v, k) => { if (v !== '') u.searchParams.append(k, v); });
    location.href = u.toString();
  };
  $$('[data-facets]').forEach((f) => f.addEventListener('submit', (e) => { e.preventDefault(); submitFacets(f); }));

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add]');
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
    let ok = false;
    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      const r = await fetch(TH.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const d = await r.json();
      if (d.status) { toast(d.description || d.message); return; }
      ok = true;
      renderSections(d.sections);
      const c = await (await fetch(TH.routes.cart + '.js')).json();
      updateCount(c.item_count);
      const qv = form.closest('dialog');
      if (qv) qv.close();
      if (TH.drawer && $('#cart-drawer')) openDrawer($('#cart-drawer')); else toast(TH.t.added);
    } catch (err) { form.submit(); } finally {
      btn.disabled = false;
      btn.innerHTML = label;
      if (ok) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1200); }
    }
  });

  const pdp = $('[data-product]');
  if (pdp) {
    const gal = $('[data-gallery]', pdp);
    const thumbs = $$('[data-thumb]', pdp);
    const dots = $$('.gallery__dots span', pdp);
    const setActive = (i) => {
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      dots.forEach((d, k) => d.classList.toggle('on', k === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.dataset.thumb);
      gal.scrollTo({ left: gal.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }));
    let gt;
    gal && gal.addEventListener('scroll', () => { clearTimeout(gt); gt = setTimeout(() => setActive(Math.round(gal.scrollLeft / gal.clientWidth)), 60); }, { passive: true });

    const vjson = $('[data-variants]');
    const variants = vjson ? JSON.parse(vjson.textContent) : [];
    const idInput = $('[data-variant-id]', pdp);
    // 30-oct: al llegar con ?variant= (p. ej. desde la 301 de una ficha de color fusionada) la galería abre en la foto de ese color
    try {
      const pv = new URL(location.href).searchParams.get('variant');
      const v0 = pv && variants.find((x) => String(x.id) === pv);
      if (v0 && v0.featured_media && gal) {
        const ir = () => { const s = gal.querySelector(`[data-media-id="${v0.featured_media.id}"]`); if (s) { gal.scrollTo({ left: s.offsetLeft, behavior: 'auto' }); } };
        if (document.readyState === 'complete') ir(); else window.addEventListener('load', ir, { once: true });
        setTimeout(ir, 600);
      }
    } catch (e) {}
    $$('[data-option]', pdp).forEach((o) => o.addEventListener('change', async () => {
      const sel = $$('.option fieldset', pdp).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      $$('[data-opt-label]', pdp).forEach((l, i) => { l.textContent = sel[i]; });
      const v = variants.find((x) => x.options.every((val, i) => val === sel[i]));
      const add = $('[data-add]', pdp);
      if (!v) { add.disabled = true; return; }
      idInput.value = v.id;
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      try {
        const html = await (await fetch(`${pdp.dataset.url}?variant=${v.id}&section_id=${pdp.dataset.section}`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-price-wrap]', '[data-stock-wrap]'].forEach((s) => { const n = doc.querySelector(s); const c = $(s, pdp); if (n && c) c.innerHTML = n.innerHTML; });
        const na = doc.querySelector('[data-add]');
        if (na) { add.disabled = na.disabled; add.textContent = na.textContent; }
        const sku = doc.querySelector('[data-sku]'); const cs = $('[data-sku]', pdp); if (sku && cs) cs.textContent = sku.textContent;
        if (v.featured_media) {
          const slide = gal.querySelector(`[data-media-id="${v.featured_media.id}"]`);
          if (slide) gal.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      } catch (err) {}
    }));

    const sticky = $('[data-sticky-atc]');
    const add = $('[data-add]', pdp);
    if (sticky && add && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(add);
      $('[data-sticky-add]', sticky).addEventListener('click', () => add.closest('form').requestSubmit());
    }
  }

  const recs = $('[data-recs]');
  if (recs && !recs.children.length) {
    fetch(recs.dataset.url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const s = doc.querySelector('[data-recs]');
      if (s && s.innerHTML.trim()) { recs.innerHTML = s.innerHTML; observeReveal(recs); } else { recs.remove(); }
    }).catch(() => recs.remove());
  }

  function observeReveal(root = document) {
    const els = $$('.reveal:not(.in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }
  observeReveal();

  const vids = $$('video[data-autoplay]');
  if (vids.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const vio = new IntersectionObserver((ents) => ents.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'metadata'; v.play().catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.5 });
    vids.forEach((v) => vio.observe(v));
  }

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const store = { get(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } }, set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };

  const swap = (sw) => {
    const card = sw.closest('[data-card]');
    const img = card.querySelector('[data-card-img]');
    if (img) { img.removeAttribute('srcset'); img.src = sw.dataset.swImg; }
    card.querySelectorAll('.sw').forEach((x) => x.classList.toggle('on', x === sw));
    const link = card.querySelector('[data-card-link]');
    if (link) link.href = sw.dataset.swUrl;
  };
  document.addEventListener('mouseover', (e) => { const sw = e.target.closest('.sw'); if (sw && window.matchMedia('(hover:hover)').matches) swap(sw); });
  document.addEventListener('click', (e) => { const sw = e.target.closest('.sw'); if (sw) { e.preventDefault(); swap(sw); } });

  const openModal = (m) => { if (m && !m.open) { lastFocus = document.activeElement; m.showModal(); } };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-modal-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  $$('dialog.modal').forEach((m) => m.addEventListener('close', () => lastFocus && lastFocus.focus && lastFocus.focus()));

  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-quick]');
    if (!q) return;
    e.preventDefault();
    const m = $('#quick-view'); const body = $('[data-qv-body]', m);
    body.innerHTML = '<div class="modal__loading"><span class="spinner spinner--dark"></span></div>';
    openModal(m);
    try {
      const html = await (await fetch(`/products/${q.dataset.quick}?view=quick`)).text();
      body.innerHTML = html;
      const sel = $('[data-qv-variant]', body);
      sel && sel.addEventListener('change', () => {
        const o = sel.selectedOptions[0];
        const add = $('[data-add]', body);
        const now = $('.price__now', body);
        if (now) now.textContent = o.dataset.price;
        $$('.price__was,.price__pct', body).forEach((x) => x.remove());
        add.disabled = o.dataset.available !== 'true';
      });
    } catch (err) { m.close(); location.href = `/products/${q.dataset.quick}`; }
  });

  const CMP = 'th_cmp';
  let cmp = store.get(CMP, []);
  const cmpBar = $('#compare-bar');
  const paintCmp = () => {
    $$('[data-compare-toggle]').forEach((b) => {
      const on = cmp.some((x) => x.h === b.dataset.compareToggle);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      const l = b.querySelector('[data-compare-label]'); if (l) l.textContent = on ? TH.t.cmp_in : TH.t.cmp_add;
    });
    if (!cmpBar) return;
    cmpBar.hidden = cmp.length === 0;
    $('[data-cmp-count]', cmpBar).textContent = TH.t.cmp_count.replace('{{ n }}', cmp.length);
    $('[data-cmp-thumbs]', cmpBar).innerHTML = cmp.map((x) => x.img ? `<img src="${esc(x.img)}" alt="">` : '').join('');
    $('[data-cmp-open]', cmpBar).disabled = cmp.length < 2;
  };
  paintCmp();
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-compare-toggle]');
    if (b) {
      e.preventDefault();
      const h = b.dataset.compareToggle;
      const i = cmp.findIndex((x) => x.h === h);
      if (i > -1) cmp.splice(i, 1);
      else if (cmp.length >= 3) { toast(TH.t.cmp_max); return; }
      else {
        const card = b.closest('[data-card]');
        const im = card ? card.querySelector('[data-card-img]') : $('[data-gallery] img');
        cmp.push({ h, img: im ? im.currentSrc || im.src : '' });
      }
      store.set(CMP, cmp); paintCmp(); return;
    }
    if (e.target.closest('[data-cmp-clear]')) { cmp = []; store.set(CMP, cmp); paintCmp(); return; }
    if (e.target.closest('[data-cmp-open]')) { openCompare(); return; }
    const rm = e.target.closest('[data-cmp-rm]');
    if (rm) { cmp = cmp.filter((x) => x.h !== rm.dataset.cmpRm); store.set(CMP, cmp); paintCmp(); if (cmp.length < 2) $('#compare-modal').close(); else openCompare(); }
  });
  async function openCompare() {
    const m = $('#compare-modal'); const body = $('[data-cmp-body]', m);
    body.innerHTML = '<div class="modal__loading"><span class="spinner spinner--dark"></span></div>';
    openModal(m);
    try {
      const items = await Promise.all(cmp.map((x) => fetch(`/products/${x.h}?view=compare`).then((r) => r.json())));
      const num = (p) => parseFloat(String(p).replace(/\./g, '').replace(',', '.'));
      const min = Math.min(...items.map((i) => num(i.price)));
      const R = TH.t.rows.split('|');
      const dims = (i) => i.ancho && i.alto ? `${i.ancho} × ${i.fondo} × ${i.alto} cm` : '—';
      const row = (label, f) => `<tr><th scope="row">${label}</th>${items.map((i) => `<td>${f(i)}</td>`).join('')}</tr>`;
      body.innerHTML = `<div class="cmp-wrap"><table class="cmp"><tr><th></th>${items.map((i) => `<td><a href="${esc(i.url)}"><img src="${esc(i.image)}" alt=""></a><a class="t" href="${esc(i.url)}">${esc(i.title)}</a><button type="button" class="rm" data-cmp-rm="${esc(i.handle)}">Quitar</button></td>`).join('')}</tr>`
        + row(R[0], (i) => `<span class="${num(i.price) === min && items.length > 1 ? 'best' : ''}">${esc(i.price)}</span>${i.compare_at ? ` <s style="color:var(--c-muted);font-size:12px">${esc(i.compare_at)}</s>` : ''}`)
        + row(R[1], dims)
        + row(R[2], (i) => i.peso ? `${esc(i.peso)} kg` : '—')
        + row(R[3], (i) => i.cajas ? esc(i.cajas) : '—')
        + row(R[4], (i) => i.caracteristicas && i.caracteristicas.length ? `<ul>${i.caracteristicas.map((c) => `<li>${esc(c)}</li>`).join('')}</ul>` : '—')
        + row(R[5], (i) => i.reviews > 0 ? `★ ${esc(i.rating)} (${esc(i.reviews)})` : '—')
        + `</table></div>`;
    } catch (err) { body.innerHTML = '<p>No se pudo cargar la comparación.</p>'; }
  }

  const fit = $('[data-fit]');
  if (fit) {
    const real = { w: parseFloat(fit.dataset.w), d: parseFloat(fit.dataset.d), h: parseFloat(fit.dataset.h) };
    const names = { w: 'Ancho', d: 'Fondo', h: 'Alto' };
    const fmt = (n) => String(Math.round(n * 10) / 10).replace('.', ',');
    const res = $('[data-fit-res]', fit);
    const calc = () => {
      const vals = {}; $$('[data-fit-in]', fit).forEach((i) => { const v = parseFloat(i.value.replace(',', '.')); if (v > 0) vals[i.dataset.fitIn] = v; });
      const keys = Object.keys(vals);
      if (!keys.length) { res.innerHTML = ''; return; }
      let all = true;
      let html = keys.map((k) => { const ok = vals[k] >= real[k]; if (!ok) all = false; const diff = Math.abs(vals[k] - real[k]); return `<li class="${ok ? 'ok' : 'no'}"><span>${names[k]}: mueble ${fmt(real[k])} cm · hueco ${fmt(vals[k])} cm</span><strong>${ok ? `✓ ${TH.t.fit_ok} (+${fmt(diff)})` : `✗ ${TH.t.fit_no} (−${fmt(diff)})`}</strong></li>`; }).join('');
      if (keys.length === 3) html += `<li class="sum">${all ? TH.t.fit_all + ' ' + keys.map((k) => `${fmt(vals[k] - real[k])} cm`).join(' · ') : TH.t.fit_some}</li>`;
      res.innerHTML = html;
    };
    fit.addEventListener('input', calc);
  }

  const sv = $('#story-viewer');
  if (sv) {
    const video = $('[data-sv-video]', sv), bars = $('[data-sv-bars]', sv);
    let list = [], idx = 0;
    const SEEN = 'th_seen';
    const seen = store.get(SEEN, []);
    $$('[data-story]').forEach((b) => { if (seen.includes(b.dataset.video)) b.classList.add('seen'); });
    const show = (i) => {
      if (i < 0) i = 0;
      if (i >= list.length) { close(); return; }
      idx = i; const b = list[i];
      bars.innerHTML = list.map((_, k) => `<span class="${k < i ? 'done' : ''}"><i></i></span>`).join('');
      video.poster = b.dataset.poster || '';
      video.src = b.dataset.video;
      video.play().catch(() => {});
      $('[data-sv-title]', sv).textContent = b.dataset.title;
      $('[data-sv-price]', sv).textContent = b.dataset.price;
      $('[data-sv-cta]', sv).href = b.dataset.href;
      if (!seen.includes(b.dataset.video)) { seen.push(b.dataset.video); store.set(SEEN, seen.slice(-80)); }
      b.classList.add('seen');
    };
    const close = () => { video.pause(); video.removeAttribute('src'); video.load(); sv.hidden = true; document.documentElement.style.overflow = ''; lastFocus && lastFocus.focus && lastFocus.focus(); };
    video.addEventListener('timeupdate', () => { const bar = bars.children[idx]; if (bar && video.duration) bar.firstChild.style.width = (video.currentTime / video.duration * 100) + '%'; });
    video.addEventListener('ended', () => show(idx + 1));
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-story]');
      if (b) { lastFocus = b; list = $$(`[data-story][data-group="${b.dataset.group}"]`); sv.hidden = false; document.documentElement.style.overflow = 'hidden'; show(list.indexOf(b)); setTimeout(() => $('[data-sv-close]', sv).focus(), 30); return; }
      if (sv.hidden) return;
      if (e.target.closest('[data-sv-close]') || e.target === sv) close();
      else if (e.target.closest('[data-sv-next]')) show(idx + 1);
      else if (e.target.closest('[data-sv-prev]')) show(idx - 1);
    });
    document.addEventListener('keydown', (e) => {
      if (sv.hidden) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(idx + 1); else if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }
})();
